module.exports = __webpack_public_path__ + "img/21.b91b05ca.jpg";